import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {PhotoCamera as PhotoCameraIcon} from 'views/icons';
import {SecureFile} from 'views/module';

import {simplifyQuestions} from 'utils/user_bio';

const CaregiverPhoto = (props) => {
  const {
    caregiverBioQuestions,
  } = props;

  const caregiverBio = React.useMemo(() => {
    if (!caregiverBioQuestions?.questions) {
      return {};
    }

    return simplifyQuestions(caregiverBioQuestions.questions);
  }, [caregiverBioQuestions]);

  const profileImg = caregiverBio?.['profilePhoto']?.[0]?.src;

  return (
    <Box
      sx={{
        textAlign: 'center',
        margin: 2,
        maxWidth: {md: '200px', xs: '100%'},
        maxHeight: '200px',
      }}
    >
      <Box
        sx={{
          marginTop: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 200,
          width: '100%',
          border: 1,
          borderColor: 'grey.400',
          borderRadius: '24px',
          bgcolor: 'background.default',
          position: 'relative',
          overflow: 'hidden',
          bgcolor: 'grey.200',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            display: 'flex',
            bgcolor: 'rgb(252, 253, 255, 0.5)',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
          }}
        >
          <PhotoCameraIcon
            fontSize="large"
            color="action"
          />
        </Box>
        {
          profileImg &&
            <SecureFile
              file={{
                name: 'Img',
                type: 'image/*',
                src: `${profileImg}`,
              }}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                background: 'white',
                zIndex: 2,
              }}
            />
        }
      </Box>
    </Box>
  );
};
CaregiverPhoto.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
};

export default React.memo(CaregiverPhoto);
